import BroadcastFormCtrl from '../../broadcast/controller/broadcast_form_ctrl.js'

export default class EpgBroadcastFormCtrl extends BroadcastFormCtrl {

    boot () {
        this.showCancel = true
    }

    goToBroadcast (broadcastId) {
        this.$state.go('epg.update', { broadcastId })
    }

    savedRedirect () {
        this.goBackRedirect()
    }

    goBackRedirect () {
        this.$state.go('epg')
    }

    addProgramRedirect (title) {
        if (this.isUpdate()) {
            this.$state.go('epg.update.program', { title })
        } else {
            this.$state.go('epg.create.program', { title })
        }
    }

    addPresenterRedirect (name) {
        if (this.isUpdate()) {
            this.$state.go('epg.update.presenter', { name })
        } else {
            this.$state.go('epg.create.presenter', { name })
        }
    }

}
